module.exports = __webpack_public_path__ + "c3bd31e01d733fb7d3788aaa016b00a3.svg";